import styled from 'styled-components';
import { SYS_BREAKPOINT_MD, SYS_BREAKPOINT_LG } from '@oneaudi/unified-web-common';

export const TeaserContainer = styled.div<{
  numberOfComponents: number;
}>`
  max-width: 1920px;
  margin: 0 auto;
  background-color: ${({ theme }) => (theme.name === 'dark' ? 'black' : 'white')};
  box-sizing: border-box;
  display: grid;
  padding-inline-start: var(--page-margin);
  padding-inline-end: var(--page-margin);

  &:first-child {
    padding-block-start: var(--spacing-relative-xl);
  }
  &:last-child {
    padding-block-end: var(--spacing-relative-xl);
  }

  @media screen and (max-width: ${SYS_BREAKPOINT_MD}) {
    ${({ numberOfComponents }) => {
      if (numberOfComponents === 1) {
        return `
          grid-template-areas:
            "a a"
            "b c";
          grid-gap: var(--spacing-relative-md);
          grid-auto-columns: 1fr;
            `;
      }
      return '';
    }}
  }

  @media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
    ${({ numberOfComponents }) => {
      if (numberOfComponents === 1 || numberOfComponents === 3) {
        return `
          grid-template-areas:
            "a a"
            "b c";
          grid-gap: var(--spacing-relative-md);
          grid-auto-columns: 1fr;
            `;
      }
      if (numberOfComponents === 2) {
        return `
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--spacing-relative-md);
            `;
      }
      return '';
    }}
  }

  @media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
    ${({ numberOfComponents }) => {
      if (numberOfComponents === 1) {
        return `
            grid-template-areas:
            "a a"
            "b c";
          grid-gap: var(--spacing-relative-md);
          grid-auto-columns: 1fr;
            `;
      }
      if (numberOfComponents === 2) {
        return `
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--spacing-relative-md);
            `;
      }

      if (numberOfComponents === 3) {
        return `
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: var(--spacing-relative-md);
            `;
      }
      return '';
    }}
  }
`;
